import script from "./FlashcardGame.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashcardGame.vue?vue&type=script&setup=true&lang=js"

import "./FlashcardGame.vue?vue&type=style&index=0&id=10cc7d54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10cc7d54"]])

export default __exports__